import { getBackVersion } from '../config';
import api from './api';

export type AuthLink = {
    path: string;
    authLink: string;
};

const getPathAuthedLink = (path: string): Promise<AuthLink> => {
    return api.request<AuthLink>({
        method: 'POST',
        url: `${getBackVersion()}/auth_link`,
        data: {
            path: path,
        },
    });
};

export default { getPathAuthedLink };
